import styled, { css } from "styled-components";

interface IProps {
    themeValue?: 'dark' | 'light';
}

export const ParagraphUI = styled.p<IProps>`

font-size: 14px;
line-height: 18px;

p,strong,span{
    font-size: 14px; 
}

color: #333;

${props => props?.themeValue === 'dark' && css`
color: #fff;
`}

`